export default __webpack_public_path__ + "static/Toyota_Tagline_Incorrect_Usage_5-5b5974d505f5f9496c7cf4bc9feeb2a3.svg";